import { render, staticRenderFns } from "./userInfo_individualHistory.vue?vue&type=template&id=55600fb7&"
import script from "./userInfo_individualHistory.vue?vue&type=script&lang=js&"
export * from "./userInfo_individualHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports